import { Alert,Snackbar, Slide } from '@mui/material'

function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
}

export default function SnackbarAlert({isOpen, alert, handleClose}){
    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={isOpen}
            onClose={handleClose}
            autoHideDuration={3000}
            TransitionComponent={TransitionDown}
        >
            <Alert severity={alert?.type} variant="filled">{alert?.message}</Alert>
        </Snackbar>
    )
}